import React, { Component } from 'react';

import CheckboxSection from "./CheckboxSection";

const ConfiguracionBasica = (props) => {
    return (
        <div>
            <div className="row">

                <CheckboxSection message={"Controlar la cantidad máxima de ingresos incorrectos consecutivos de la contraseña: "}
                    subMessage="Alcanzada la cantidad máxima de intentos, el usuario será bloqueado. "
                    isChecked={props.cantIntentosFallidos != null}
                    value={props.cantIntentosFallidos}
                    extencion=" intentos"
                    checkboxChangeState={props.checkboxChangeState}
                    identifier="cantIntentosFallidos"
                    textChangeState={props.textChangeState}/>

                <CheckboxSection message={"Controlar el tiempo de vigencia de la contraseña para un usuario: "}
                    subMessage="Alcanzada la cantidad máxima de días, el usuario deberá cambiar la contraseña. "
                    isChecked={props.maxDiasCaducidad != null}
                    value={props.maxDiasCaducidad}
                    extencion=" días"
                    checkboxChangeState={props.checkboxChangeState}
                    identifier="maxDiasCaducidad"
                    textChangeState={props.textChangeState}/>

                <CheckboxSection message={"Controlar el tiempo máximo sin que el usuario inicie sesión: "}
                    subMessage="Alcanzada la cantidad máxima de días, el usuario será bloqueado. "
                    isChecked={props.maxDiasInactividad != null}
                    value={props.maxDiasInactividad}
                    extencion=" días"
                    checkboxChangeState={props.checkboxChangeState}
                    identifier="maxDiasInactividad"
                    textChangeState={props.textChangeState}/>

                <CheckboxSection message={"Permitir que una sesión permanezca abierta sin que el usuario esté operando: "}
                    subMessage="Una vez que haya terminado el tiempo definido se cerrará la sesión."
                    isChecked={props.minutosPermitidosInactividad != null}
                    value={props.minutosPermitidosInactividad}
                    extencion=" minutos"
                    checkboxChangeState={props.checkboxChangeState}
                    identifier="minutosPermitidosInactividad"
                    textChangeState={props.textChangeState}/>

                <CheckboxSection message={"Guardar las últimas contraseñas utilizadas por el usuario: "}
                    isChecked={props.cantidadRepeticiones != null}
                    value={props.cantidadRepeticiones}
                    extencion=" contraseña/s"
                    checkboxChangeState={props.checkboxChangeState}
                    identifier="cantidadRepeticiones"
                    textChangeState={props.textChangeState}/>
            </div>


        </div>
    );
};

export default ConfiguracionBasica;